<div class="bulk-actions__wrapper">
	<freud-card class="bulk-actions__card">
		<div class="zk-flex zk-gap-3 zk-items-center">
			<div class="bulk-actions__title">
				{{ selectedContacts.length }} {{'CONTACT.BULK_ACTIONS.SELECTED_CONTACTS' | translate}}
			</div>
			<freud-button
				class="bulk-actions__button"
				(click)="isBullkMessagesModalOpen = true"
				icon="freud-icon freud-icon-message-circle"
			>
				{{'CONTACT.BULK_ACTIONS.SEND_MESSAGE' | translate}}</freud-button
			>
		</div>
	</freud-card>
</div>
<contact-bulk-message
	[visible]="isBullkMessagesModalOpen"
	(closeModal)="isBullkMessagesModalOpen = false"
	[selectedContacts]="selectedContacts"
	(onSendMessage)="onSendMessage.emit()"
></contact-bulk-message>
